module.exports = __webpack_public_path__ + "img/cw.f1b3043c.svg";